import React     from 'react';
import PropTypes from 'prop-types'

const ParameterSummary = (props) => {
  const { showSummary } = props
  if (!showSummary) return null;

  return (
    <div className="summary">
      <div className="parameters-summary">
        <table className="table table-bordered parameters-summary-table">
          <tbody>
            <tr>
              <td className="title" colSpan="2"> NUMBER OF PLACEMENTS</td>
              <td className="key"> BOM lines:</td>
              <td className="value"> {props.parameters.bom_line_items} </td>
            </tr>
            <tr>
              <td className="key"> SMT:</td>
              <td className="value"> {props.parameters.smt || '-'} </td>
              <td className="key"> Lead-Free Processing:</td>
              <td className="value">
                {(props.parameters.lead_free == 1) ? 'Yes' : 'No'}
              </td>
            </tr>
            <tr>
              <td className="key"> Thru-hole:</td>
              <td className="value"> {props.parameters.thru_hole || '-'} </td>
              <td className="key"> Double-sided SMT:</td>
              <td className="value">
                {(props.parameters.double_sided_smt == 1) ? 'Yes' : 'No'}
              </td>
            </tr>
            <tr>
              <td className="key"> BGA:</td>
              <td className="value"> {props.parameters.bga || '-'} </td>
              <td className="key"> Class III Inspection:</td>
              <td className="value">
                {(props.parameters.class_3_inspection == 1) ? 'Yes' : 'No'}
              </td>
            </tr>
            <tr>
              <td className="key"> QFN:</td>
              <td className="value"> {props.parameters.qfn || '-'} </td>
              <td className="key" />
              <td className="value" />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

ParameterSummary.propTypes = {
  showSummary: PropTypes.bool.isRequired,
}

export default ParameterSummary
